import axios, { AxiosInstance } from 'axios';
import { tokenService } from '../services/TokenService';

export const API_CONFIG = {
    baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api/bff",
    timeout: Number(process.env.API_TIMEOUT) || 30000,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: false,
};

// Create axios instance
const axiosInstance: AxiosInstance = axios.create(API_CONFIG);

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = tokenService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;